<div class="page-wrapper">
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12">
                <div class="login-card">
                    <div>
                        <div>
                            <a class="logo" routerLink='/'>
                                <img class="img-fluid for-light" src="assets/images/login/logo.png" width="200"
                                    alt="looginpage">
                                <img class="img-fluid for-dark" src="assets/images/login/logo.png" width="200"
                                    alt="looginpage">
                            </a>
                        </div>
                        <div class="login-main" *ngIf="mostrarTabla">
                            <form class="theme-form">
                                <h4>Verificar código</h4>
                                <div class="form-group">
                                    <label class="col-form-label">Ingresá el codigo enviado a tu correo
                                        electrónico</label>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <input [(ngModel)]="codigo" class="form-control mb-1" type="text"
                                                [maxlength]="6" required="" placeholder="123456"
                                                (input)="onInputChange($event)">
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary btn-pill d-block w-100 m-t-10" type="submit"
                                                (click)="resetPassword()">Verificar</button>
                                        </div>
                                        <div class="text-center mt-4 mb-4">
                                            <span class="reset-password-link">Aun no sos paciente?  <a
                                                    class="btn-link text-danger" [routerLink]="'/register'">Registrate
                                                    aquí</a></span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="login-main" *ngIf="!mostrarTabla">
                            <form class="theme-form">
                                <h4>Cambiar contraseña</h4>
                                <div class="form-group">
                                    <div class="row">
                                        <label class="col-form-label">Ingresá nueva contraseña</label>
                                        <div class="col-md-12 mb-2">
                                            <input [(ngModel)]="password" class="form-control mb-1" type="password"
                                                placeholder="******" name="password" id="password" required>
                                        </div>
                                        <label class="col-form-label">Repite contraseña</label>
                                        <div class="col-md-12 mb-2">
                                            <input [(ngModel)]="newPassword" class="form-control mb-1" type="password"
                                                placeholder="******" name="newPassword" id="newPassword" required>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary btn-pill d-block w-100 m-t-10" type="submit"
                                                (click)="changePassword()">Aceptar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>